module.exports = __webpack_public_path__ + "static/img-banner-paynebot-f08f3bef44555c1e5fe5546b8a92b1f5.png";